module.exports = __webpack_public_path__ + "static/media/select.4f78f109.png";